import { Box } from "@mui/material";
import logo from "../../../assets/images/logo.svg";

function Header() {
  return (
    <Box
      component="header"
      sx={{
        height: "140px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: { xs: 2, md: 18 },
        py: 4,
        backgroundColor: "background.default",
        position: "relative",
      }}
    >
      {/* Logo */}
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <img
          src={logo}
          alt="Logo"
          style={{
            height: 80,
            width: 206,
            objectFit: "contain",
            cursor: "pointer",
          }}
          onClick={() => (window.location.href = "/")}
        />
      </Box>
    </Box>
  );
}

export default Header;
